var layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
var layout3 = "col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4";
var layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
var layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
var hideShowFiltersEvent = false;
var clearAllFilterButton = false;
let clearAllButton = document.getElementById('yv-applied-filter-cross-all');
var filters = document.getElementById('filterSideBar');
var filterContainer = document.getElementById('CollectionProductsContainer');
if(clearAllButton){
  clearAllFilterButton = true;
}
function changeGridLayout() {
    let parent = document.getElementById('CollectionProductsContainer');
    let gridLayouts = document.querySelectorAll('.sort-grid-icon');
    Array.from(gridLayouts).forEach(function(layoutItem) {
        layoutItem.classList.remove('active');
    });

    var grid_layout_collection = Cookies.get('grid_layout_collection');
    if (parent && gridLayouts.length > 0) {
        if (window.innerWidth < 768) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                const iconEl = document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]');
                if (iconEl) iconEl.classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                const iconEl = document.querySelector('.sort-grid-icon[data-value="grid-layout-2"]');
                if (iconEl) iconEl.classList.add('active');
                parent.setAttribute("data-view", "grid-layout-2")
            }
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                const iconEl = document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]');
                if (iconEl) iconEl.classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                const iconEl = document.querySelector('.sort-grid-icon[data-value="grid-layout-3"]');
                if (iconEl) iconEl.classList.add('active');
                parent.setAttribute("data-view", "grid-layout-3")
            }
        } else if (window.innerWidth >= 992) {
            if (grid_layout_collection) {
                const iconEl = document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]');
                if (iconEl) iconEl.classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                const iconEl = document.querySelector('.sort-grid-icon[data-value="grid-layout-4"]');
                if (iconEl) iconEl.classList.add('active');
                parent.setAttribute("data-view", "grid-layout-4")
            }
        }
        updateGridView(parent);
        Array.from(gridLayouts).forEach(function(btn) {
            btn.setAttribute('aria-pressed', btn.classList.contains('active') ? 'true' : 'false');
        });
    }
}

// Filter drawer accessibility helpers.
// The closed drawer is moved off-screen with transform only, which leaves its
// contents in the caret and Tab path. inert removes the closed drawer from
// caret browsing, the Tab order and the accessibility tree in one step, and we
// keep aria-expanded and focus in sync with the open/closed state.
function getFilterDrawerEls() {
    return {
        toggle: document.getElementById('filterHeading'),
        panel: document.getElementById('filterSideBar'),
        container: document.getElementById('CollectionProductsContainer')
    };
}

function filterDrawerState() {
    var els = getFilterDrawerEls();
    if (!els.toggle || !els.panel) return null;
    var isMobile = window.innerWidth < 768;
    var isDrawer = els.toggle.classList.contains('filters-drawer-toggle');
    // Desktop sidebar mode keeps the filters permanently in the page flow.
    if (!isMobile && !isDrawer) return 'sidebar';
    if (isMobile) return els.panel.classList.contains('active') ? 'open' : 'closed';
    return (els.container && els.container.classList.contains('filters-toggle')) ? 'closed' : 'open';
}

function filterDrawerFocusable(panel) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
    return Array.from(panel.querySelectorAll(sel)).filter(function(el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
}

function syncFilterDrawerA11y(opts) {
    opts = opts || {};
    var els = getFilterDrawerEls();
    if (!els.toggle || !els.panel) return;
    var state = filterDrawerState();
    if (state === 'sidebar') {
        els.panel.removeAttribute('inert');
        els.toggle.setAttribute('aria-expanded', 'true');
        return;
    }
    if (state === 'open') {
        els.panel.removeAttribute('inert');
        els.toggle.setAttribute('aria-expanded', 'true');
        if (opts.focus) {
            els.panel.setAttribute('tabindex', '-1');
            els.panel.focus({ preventScroll: true });
        }
    } else {
        // Move focus back to the toggle before inerting, otherwise the browser
        // drops focus to the body and the return-focus contract breaks.
        if (els.panel.contains(document.activeElement)) {
            els.toggle.focus();
        }
        els.panel.setAttribute('inert', '');
        els.toggle.setAttribute('aria-expanded', 'false');
    }
}

function closeFilterDrawer() {
    var els = getFilterDrawerEls();
    if (!els.toggle || !els.panel) return;
    if (window.innerWidth < 768) {
        els.panel.classList.remove('active');
        document.querySelector('body').classList.remove('open-filter-popup');
        document.querySelector('body').classList.remove('open-filter-sort');
    } else if (els.toggle.classList.contains('filters-drawer-toggle') && els.container) {
        els.container.classList.add('filters-toggle');
    }
    syncFilterDrawerA11y();
    els.toggle.focus();
}

function bindFilterDrawerKeys() {
    var els = getFilterDrawerEls();
    if (!els.panel || els.panel.dataset.drawerKeysBound) return;
    els.panel.dataset.drawerKeysBound = '1';
    els.panel.addEventListener('keydown', function(e) {
        if (filterDrawerState() !== 'open') return;
        if (e.key === 'Escape' || e.key === 'Esc') {
            e.preventDefault();
            closeFilterDrawer();
        } else if (e.key === 'Tab') {
            var f = filterDrawerFocusable(els.panel);
            if (!f.length) return;
            var first = f[0];
            var last = f[f.length - 1];
            if (e.shiftKey && (document.activeElement === first || document.activeElement === els.panel)) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });
}

function hideShowFilters() {
    var filterHeading = document.getElementById('filterHeading');
    if (window.innerWidth < 768) {
        if (filterContainer && filterHeading) {
            if (filterHeading.classList.contains('filters-drawer-toggle')) {
                filterContainer.classList.add('filters-toggle');
            }
        }
    } else {
        if (filters) {
            filters.classList.remove('active')
            document.querySelector('body').classList.remove('open-filter-sort');
            document.querySelector('body').classList.remove('open-filter-popup');
        }
    }
    syncFilterDrawerA11y();
    if (hideShowFiltersEvent == false ) {
        if (filterHeading) {
            filterHeading.addEventListener("click", (e) => {
              e.preventDefault();
                if (window.innerWidth > 767) {
                    if (filterContainer && filterHeading) {
                        if (filterHeading.classList.contains('filters-drawer-toggle')) {
                            DOMAnimations.classToggle(filterContainer, 'filters-toggle');
                            syncFilterDrawerA11y({ focus: true });
                        }
                    }
                } else {
                    if (filters) filters.classList.add('active');
                    document.querySelector('body').classList.add('open-filter-popup');
                    document.querySelector('body').classList.add('open-filter-sort');
                    syncFilterDrawerA11y({ focus: true });
                }
            });
        }
        bindFilterDrawerKeys();
        hideShowFiltersEvent = true;
    }
}
function hideFilters(){
  var cancelFiltes = document.getElementById('cancelFilters');
  if (cancelFiltes) {
    cancelFiltes.addEventListener("click", (e) => {
      e.preventDefault();
      closeFilterDrawer();
    });
  }
}
/* ── Collection filter swatch colours ──────────────────────────────────
   Shopify's native swatch system sets background-image on the inner
   .filter-swatch-img span from the swatch image, which can be any photo
   or texture. We override that inline style and drive a solid colour from
   the colour name text instead, matching the approach used in product hub. */
function applyCollectionSwatchColors() {
    var colourMap = {
        'beige':'beige','black':'#000','blue':'#2979ff','brown':'#795548',
        'charcoal':'#36454f','coral':'coral','cream':'#fffdd0','cyan':'cyan',
        'gold':'gold','green':'#43a047','grey':'#9e9e9e','gray':'#9e9e9e',
        'hot pink':'hotpink','indigo':'indigo','ivory':'ivory','khaki':'#c3b091',
        'lavender':'lavender','lilac':'#c8a2c8','lime':'lime','magenta':'magenta',
        'maroon':'maroon','mauve':'#e0b0ff','mint':'#98ff98',
        'multi':'linear-gradient(135deg,red 33%,yellow 33%,yellow 66%,blue 66%)',
        'multicolour':'linear-gradient(135deg,red 33%,yellow 33%,yellow 66%,blue 66%)',
        'multicolor':'linear-gradient(135deg,red 33%,yellow 33%,yellow 66%,blue 66%)',
        'mustard':'#ffdb58','navy':'#0a1045','navy blue':'#0a1045','nude':'#e3bc9a',
        'off white':'#f5f5f0','off-white':'#f5f5f0','olive':'olive','orange':'orange',
        'peach':'#ffcba4','pink':'#f48fb1','purple':'#7b1fa2','red':'#e53935',
        'rose':'#e91e63','rose gold':'#b76e79','salmon':'salmon','silver':'#bdbdbd',
        'tan':'tan','teal':'teal','turquoise':'turquoise','violet':'#9c27b0',
        'white':'#fff','yellow':'#fdd835',
        'dark blue':'#1565c0','dark green':'#1b5e20','dark grey':'#424242',
        'dark gray':'#424242','dark red':'#b71c1c','light blue':'#90caf9',
        'light green':'#a5d6a7','light grey':'#e0e0e0','light gray':'#e0e0e0',
        'light pink':'#f8bbd0','sky blue':'#87ceeb','forest green':'#228b22',
        'burgundy':'#800020','caramel':'#c68642','chocolate':'#5d4037',
        'fuchsia':'fuchsia','baby pink':'#ffb6c1'
    };
    document.querySelectorAll('.swatch-filter .yv-filter-item').forEach(function(item) {
        var inner = item.querySelector('.filter-swatch-img');
        var textEl = item.querySelector('.filter-swatch-text');
        if (!inner || !textEl) return;
        var name = textEl.textContent.replace(/\s*\(\d+\)\s*$/, '').trim().toLowerCase();
        var colour = colourMap[name];
        if (!colour) colour = name;
        if (colour.indexOf('gradient') > -1) {
            inner.style.backgroundImage = colour;
            inner.style.backgroundColor = '';
        } else {
            inner.style.backgroundColor = colour;
            inner.style.backgroundImage = '';
        }
    });
}

window.addEventListener('load', (event) => {
    changeGridLayout();
    hideShowFilters();
    applyFilters();
    sortByOptions();
    showMoreFilters();
    hideFilters();
    sortBy();
    applyCollectionSwatchColors();
});
window.addEventListener('resize', function(event) {
    changeGridLayout();
    applyFilters();
    hideShowFilters();
    sortByVisibilityChange(); 
    var filters = document.getElementById('filterSideBar');
    if (filters) {
        if (window.innerWidth < 768 && window.innerWidth > 760) {
            filters.style.display = 'none';
            setTimeout(function() { filters.style.display = ''; }, 500)
        }
    }

});

function showMoreFilters() {
    const filterForm = document.getElementById('FiltersForm');
    if(filterForm){
        var showMoreFilters = filterForm.querySelectorAll('.filters-expand');
        if (showMoreFilters) {
            Array.from(showMoreFilters).forEach(function(showMoreFilter) {
                showMoreFilter.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (showMoreFilter.classList.contains('active')) {
                        showMoreFilter.classList.remove('active');
                        DOMAnimations.slideUp(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showMoreText;
                    } else {
                        showMoreFilter.classList.add('active');
                        DOMAnimations.slideDown(showMoreFilter.parentNode.querySelector('.more-options'), 150);
                        showMoreFilter.querySelector('span').textContent = showLessText;
                    }
                });
            });
        }
    }
}

function applyFilters() {
    var section = document.getElementById('CollectionProductsContainer');
    if (section) {
        var sectionParent = section.closest('.shopify-section');
        var sectionId = section.dataset.id;
        const filterForm = document.getElementById('FiltersForm');
        if (!filterForm) {
            return false;
        }
        //   showMultipleOptions(); 
        var layouts = sectionParent.querySelectorAll('.sort-grid-icon');
        Array.from(layouts).forEach(function(layout) {
            layout.addEventListener("click", (e) => {
                e.preventDefault();
                if (!layout.classList.contains('active')) {
                    layout.classList.add('active');
                    layout.setAttribute('aria-pressed', 'true');
                    let allGrids = section.querySelectorAll('.aos-init');

                    Array.from(allGrids).forEach(function(grid) {
                        grid.classList.remove('aos-animate');
                        grid.classList.remove('aos-init');
                    });

                    setTimeout(function() {
                        Array.from(layouts).forEach(function(layoutItem) {
                            if (layoutItem != layout) {
                                layoutItem.classList.remove('active');
                                layoutItem.setAttribute('aria-pressed', 'false');
                            }
                        });
                        var _thisLayout = layout.dataset.value;
                        section.setAttribute('data-view', _thisLayout)
                        updateGridView(section);
                        var date = new Date();

                        date.setTime(date.getTime() + (parseInt(24 * 60 * 60 * 1000)));
                        Cookies.set('grid_layout_collection', _thisLayout, { expires: date, path: '/' });
                        let allImages = section.querySelectorAll('.lazyloaded');

                        Array.from(allImages).forEach(function(image) {
                            image.classList.remove('lazyloaded');
                            image.classList.add('lazyload');
                        });
                    }, 800);
                }

            });
        });

        var priceRangeBars = filterForm.querySelectorAll('.mall-slider-handles');
        Array.from(priceRangeBars).forEach(function(rangeBar) {
            var el = rangeBar;
            var sliderEventListener = '';
            if (el.noUiSlider) {
                sliderEventListener = el.noUiSlider;
            } else {
                sliderEventListener = noUiSlider.create(el, {
                    step: 1,
                    connect: true,
                    start: [(parseFloat(el.dataset.start) || 0), parseFloat((el.dataset.end || el.dataset.max ))],
                    range: {
                        min: [parseFloat(el.dataset.min) || 0],
                        max: [parseFloat(el.dataset.max) || 100]
                    }
                });
                var handles = el.querySelectorAll('.noUi-handle');
                if (handles[0]) handles[0].setAttribute('aria-label', 'Minimum price');
                if (handles[1]) handles[1].setAttribute('aria-label', 'Maximum price');
            }
            if (window.innerWidth > 767) {
                sliderEventListener.on('change', function(values) {
                    var minRange = $(this)[0].options.range.min;
                    var maxRange = $(this)[0].options.range.max;
                    var minVal = parseFloat(values[0]);
                    var newformatMoney = moneyFormat;
                    if (minVal >= minRange) {
                        section.querySelectorAll('input[name="filter.v.price.gte"]')[0].value = minVal;
                    }
                    var maxVal = parseFloat(values[1]);
                    if (maxVal <= maxRange) {
                        section.querySelectorAll('input[name="filter.v.price.lte"]')[0].value = maxVal;
                    }
                    if (window.innerWidth > 767) {
                        getFilterData(rangeBar, sectionId);
                    }
                })
            }
            sliderEventListener.on("update", function(values) {
                var minRange = $(this)[0].options.range.min;
                var maxRange = $(this)[0].options.range.max;
                var minVal = parseFloat(values[0]);
                if (minVal >= minRange) {
                    section.querySelectorAll('input[name="filter.v.price.gte"]')[0].value = minVal;
                }
                var maxVal = parseFloat(values[1]);
                if (maxVal <= maxRange) {
                    section.querySelectorAll('input[name="filter.v.price.lte"]')[0].value = maxVal;
                }
                var sliderHandles = el.querySelectorAll('.noUi-handle');
                if (sliderHandles[0]) sliderHandles[0].setAttribute('aria-valuenow', Math.round(minVal));
                if (sliderHandles[1]) sliderHandles[1].setAttribute('aria-valuenow', Math.round(maxVal));
            })
        })

        if (window.innerWidth > 767) {
            var prices = filterForm.querySelectorAll('input[type=number]');
            Array.from(prices).forEach(function(price) {
                price.addEventListener("change", () => {
                    getFilterData(price, sectionId)
                });
            });
            var inputs = filterForm.querySelectorAll('input[type=checkbox],input[type=radio]');
            Array.from(inputs).forEach(function(input) {
                input.addEventListener("click", () => {
                  if (window.innerWidth > 767) {
                    getFilterData(input, sectionId)
                  }
                });
            });
        } else {
            filterForm.addEventListener("submit", (e) => {
                e.preventDefault();
                getFilterData(filterForm, sectionId)
                // document.querySelector('body').classList.remove('open-filter-sort');
            });
        }

      var removeFilters = sectionParent.querySelectorAll('a.yv-applied-filter-remove');
        Array.from(removeFilters).forEach(function(removeFilter) {
            if(removeFilter.id == 'yv-applied-filter-cross-all' & clearAllFilterButton == false){
              return false;
            }
          else{
              clearAllFilterButton == false
              removeFilter.addEventListener("click", (e) => {
                  e.preventDefault();
                  var _url = removeFilter.getAttribute('href');
                  getFilterData(removeFilter, sectionId, _url);
              });
            }
        });
    }
}

function sortByOptions() {
    var section = document.getElementById('CollectionProductsContainer');
    // Sort options are links so caret browsing and the keyboard can activate
    // them; a radio cannot be actuated by a caret. The click is intercepted for
    // the AJAX path, and without JS the link still navigates to the sorted URL.
    var sortLinks = document.querySelectorAll('#sort__list a[data-sort-by]');
    if (section) {
        var sectionId = section.dataset.id;
        Array.from(sortLinks).forEach(function(link) {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                Array.from(sortLinks).forEach(function(other) {
                    other.closest('li').classList.remove('selected');
                    other.removeAttribute('aria-current');
                });
                link.closest('li').classList.add('selected');
                link.setAttribute('aria-current', 'true');
                var sortMenu = document.getElementById('sort__list');
                var sortBtn = document.querySelector('.collection-sortby-selected');
                if (sortMenu && sortMenu.classList.contains('active')) {
                    sortMenu.classList.remove('active');
                    if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
                    if (window.innerWidth > 767) {
                        DOMAnimations.slideUp(sortMenu);
                    } else {
                        document.querySelector('body').classList.remove('open-filter-sort');
                    }
                }
                document.querySelector('body').classList.remove('open-filter-sort');
                getFilterData(link, sectionId);
            });
        });
    }
}
function sortByVisibilityChange(){
     var sortMenu = document.querySelector('.collection-sortby-selected');
    var sortList = document.getElementById('sort__list');
    if (sortMenu && sortList) {
        if (window.innerWidth > 767) {
          if(sortList.classList.contains('active')){
            sortList.style.display = 'block';
          }else{
            sortList.style.display = 'none';
          }
          document.querySelector('body').classList.remove('open-filter-sort');
          
        }else{
          sortList.style.display = 'block';
          if(sortList.classList.contains('active')){
          document.querySelector('body').classList.add('open-filter-sort');
          }else{
          document.querySelector('body').classList.remove('open-filter-sort');
          }
        }
    }
}
function sortBy() {
    var sortMenu = document.querySelector('.collection-sortby-selected');
    if (sortMenu) {
        sortMenu.addEventListener("click", (e) => {
            e.preventDefault();
            var sortBtn = e.currentTarget;
            var sortList = document.getElementById('sort__list');
            if (sortList.classList.contains('active')) {
                sortList.classList.remove('active');
                sortBtn.setAttribute('aria-expanded', 'false');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideUp(sortList);
                } else {
                    document.querySelector('body').classList.remove('open-filter-sort');
                }
            } else {
                sortList.classList.add('active');
                sortBtn.setAttribute('aria-expanded', 'true');
                if (window.innerWidth > 767) {
                    DOMAnimations.slideDown(sortList);
                } else {
                    document.querySelector('body').classList.add('open-filter-sort');
                }
            }
        });
    }
    var closeSortMenu = document.querySelector('.close-sort');
    if (closeSortMenu) {
        closeSortMenu.addEventListener("click", (e) => {
            e.preventDefault();
            var sortList = document.getElementById('sort__list');
            if (window.innerWidth < 768) {
                sortList.classList.remove('active');
                document.querySelector('body').classList.remove('open-filter-sort');
                var sortBtn = document.querySelector('.collection-sortby-selected');
                if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
            }
        });
    }
}

function updateGridView(section) {
    if (section) {
        var mainSection = document.getElementById('CollectionProductsContainer');
        var _layout = mainSection.getAttribute('data-view');
        var productItems = section.querySelectorAll('[data-product-grid]');
        if (productItems.length > 0) {
            Array.from(productItems).forEach(function(item) {
                if (_layout == 'grid-layout-2') {
                    item.setAttribute('class', layout2);
                } else if (_layout == 'grid-layout-3') {
                    item.setAttribute('class', layout3);
                } else if (_layout == 'grid-layout-4') {
                    item.setAttribute('class', layout4);
                } else if (_layout == 'grid-layout-5') {
                    item.setAttribute('class', layout5);
                }
            });
        }
        if(animationStatus){
          if (AOS) { 
            AOS.refreshHard() 
          }
        }
    }
}

function fetchFilterData(url) {
    return fetch(url)
        .then(response => response.text())
}

function getFilterData(input, sectionId, remove) {
    //   document.getElementById('CollectionProductsContainer').querySelector('.filteredData').classList.add('filtering')

    var collectionContainer = document.getElementById('CollectionProductsContainer');
    if (collectionContainer) collectionContainer.setAttribute('aria-busy', 'true');
    let allGrids = collectionContainer ? collectionContainer.querySelectorAll('.aos-init') : [];

    Array.from(allGrids).forEach(function(grid) { 
        grid.classList.remove('aos-animate');
        grid.classList.remove('aos-init');
    });
    let filterForm = document.getElementById('FiltersForm');
    const formData = new FormData(filterForm);
    var searchParameters = new URLSearchParams(formData).toString();
    var clearAll = document.getElementById('yv-applied-filter-cross-all');
    
    var url = window.location.pathname + '?section_id=' + sectionId + '&' + searchParameters;
    var _updateUrl = window.location.pathname + '?' + searchParameters;
    // Sort lives in the sort links (data-sort-by), not the filter form, so carry
    // the active sort into filter requests; otherwise filtering would reset it.
    // A sort action marks its link before calling this and passes no remove URL.
    var triggeredSort = (input.getAttribute('name') === 'sort_by') || (input.getAttribute('data-sort-by') !== null);
    var activeSortLink = document.querySelector('#sort__list a[data-sort-by][aria-current="true"]');
    if (!remove && activeSortLink && activeSortLink.getAttribute('data-value')) {
        var sortParam = '&sort_by=' + encodeURIComponent(activeSortLink.getAttribute('data-value'));
        url += sortParam;
        _updateUrl += sortParam;
    }
    if (remove) {
        url = remove;
        _updateUrl = remove;
    }
    const html = fetchFilterData(url).
    then((responseText) => {
        const resultData = new DOMParser().parseFromString(responseText, 'text/html');
        var itemResultCount = resultData.querySelector('.products-count');
        var sortByHtml = '';
        if (resultData.getElementById('toolbox-sort')) {
            sortByHtml = resultData.getElementById('toolbox-sort').innerHTML;
        }

        var html = resultData.getElementById('CollectionProductsContainer');
        var resultClear = resultData.getElementById('yv-applied-filter-cross-all')
        if (resultClear) {
            if (!document.getElementById('yv-applied-filter-cross-all')) {
                document.querySelector('.filter-heading-wrapper').appendChild(resultClear);
                clearAllFilterButton = true;
            }
          else{
            clearAllFilterButton = false;
          }
        }else{
            if (clearAll) {
                clearAll.remove();
                clearAllFilterButton = false;
            }
        }
        var elmnt = collectionContainer || document.getElementById('CollectionProductsContainer');
        updateGridView(html);
        if (html) {
            elmnt.innerHTML = html.innerHTML;
        } else {
            let productResultContainer = elmnt.querySelector('[data-collection-products]');
            if (productResultContainer) {
                productResultContainer.innerHTML = noResultFound;
            }
        }
        elmnt.setAttribute('aria-busy', 'false');

        document.querySelector('body').classList.remove('open-filter-sort');
        document.querySelector('body').classList.remove('open-filter-popup');
        filters = document.getElementById('filterSideBar');
        filterContainer = elmnt;
        let inputId = input.getAttribute('id');
        let updateInput = document.getElementById(inputId);
        if (updateInput) {
            updateInput.focus();
            let moreOption = updateInput.closest('.more-options');
            if (moreOption) {
                moreOption.style.display = 'block';
                let moreOptionText = updateInput.closest('.yv-filter-content').querySelector('.filters-expand');
                if (moreOptionText) {
                    moreOptionText.classList.add('active');
                    moreOptionText.querySelector('span').innerHTML = showLessText;

                }
            }
        }
        if (itemResultCount) {
            document.querySelector('.products-count').innerHTML = itemResultCount.innerHTML;
            var filterAnnouncer = document.querySelector('[data-collection-filter-announce]');
            if (filterAnnouncer) {
                filterAnnouncer.textContent = itemResultCount.textContent.trim();
            }
        }
        if (document.getElementById('toolbox-sort')) {
            document.getElementById('toolbox-sort').innerHTML = sortByHtml;
        }
        sortBy();
        applyFilters();
        showMoreFilters();
        if(filters && filters.querySelector('[name="sort_by"]')){
            sortByOptions()
        }
        // The sort button is re-rendered above, so return focus to it after a
        // sort so keyboard and caret users are not dropped to the page top.
        if (triggeredSort) {
            var refocusSortBtn = document.querySelector('.collection-sortby-selected');
            if (refocusSortBtn) refocusSortBtn.focus({ preventScroll: true });
        }
        // hideShowFiltersEvent = false;
        hideFilters();
        // The sidebar is re-rendered above, so re-attach the drawer key handler
        // and re-apply inert/aria to the fresh panel for its current state.
        bindFilterDrawerKeys();
        syncFilterDrawerA11y();
        if(animationStatus){
          if (AOS) { 
            AOS.refreshHard() 
          }
        }
        productHoverSlider();
        applyCollectionSwatchColors();
        if (!triggeredSort && elmnt.closest('.yv-collection-container')) {
            elmnt.closest('.yv-collection-container').scrollIntoView({ top: 150, behavior: "smooth" });
        }
        history.pushState({}, null, _updateUrl);
    });
}



let triggered = false;

function ScrollExecute() {
    var moreButon = $('#more').last();
    var nextUrl = moreButon.find('a').attr("href");
    if (screenVisibility(moreButon) && (triggered == false)) {
        triggered = true;
        $.ajax({
                url: nextUrl,
                type: 'GET',
                beforeSend: function() {
                    moreButon.find('.load').removeClass('hidden');
                }
            })
            .done(function(data) {
                moreButon.remove();
                var e = document.createElement('div');
                e.innerHTML = $(data).find('#CollectionProductsContainer').html();
                updateGridView(e)
                $('[data-collection-products]').append(e.querySelector('[data-collection-products]').innerHTML);
                productVariants();
                gridPickUpAvailability();
                productHoverSlider();
                if(animationStatus){
                  if (AOS) { 
                    AOS.refreshHard() 
                  }
                }
                triggered = false
            });
    }
}
$(document).ready(function() {
    $(window).scroll(function() {
        ScrollExecute();
    });
});